import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivel = props => {
  return (
    <option dato1={props.elemento.codigoTipoOS}>{props.elemento.descrTipoOS}</option>
  )
};

const Lista = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrTipoOS" id="miLista" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const AddCaOST2 = ({styles, list, handleLista, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Categoría Tipo OS nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrCategOST" id="descrCategOST" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrCategOST'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Observaciones</label>
                  <Form.Input autoComplete="off" name="observCategOST" id="observCategOST" onChange={handleChange} placeholder='Observaciones' icon={!errors.length?null: _find(errors, {path:'observCategOST'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Tipo de OS</label>
                  <Lista list={list} styles={styles} handleLista={handleLista} />
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
          </div>
        </div>
      </Form>
      </div>
    </div>
  )
}

export default AddCaOST2
